<template>
  <div class="content-container flex-row">

    <!-- Not loading and No objekt -->
    <section class="content xlarge-padding white" v-if="!loading && items.length < 1">
      <a href="javascript:;" @click="openCreateObjektModal()" class="button action fixed right glyph data-modal">
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <use xlink:href="/static/sprites.svg#button-glyph-object"></use>
        </svg>
        <span>Nytt objekt</span></a>

      <div class="center-container">
        <div class="center-content">
          <div class="placeholder-icon">
            <svg width="64px" height="64px" viewBox="0 0 28 28">
              <use xlink:href="/static/sprites.svg#glyph-medium-object"></use>
            </svg>
          </div>
          <span>
            <h2 class="bold">Ingen objekter</h2>
            <p>Denne kontrakten mangler objekter. Start med å legge til et objekt.</p>
          </span>
        </div>
      </div>
      <div class="placeholder-bottom-icon">
        <svg width="100%" height="100%" viewBox="0 0 28 28">
          <use xlink:href="/static/sprites.svg#glyph-medium-object"></use>
        </svg>
      </div>
    </section>

    <TheLoader :active="loading"/>
    <TheLoader :active="updating" style="opacity:0.5"/>

    <!-- Not loading and Have objekt -->
    <section class="content white" v-if="!loading && items.length > 0">
      <a href="javascript:;" @click="openCreateObjektModal()" class="button action fixed right glyph data-modal">
        <svg width="16px" height="16px" viewBox="0 0 16 16">
          <use xlink:href="/static/sprites.svg#button-glyph-object"></use>
        </svg>
        <span>Nytt objekt</span>
      </a>

      <table class="large fixed sortable sticky-table-header clickable evenodd contracts table-filter" style="height: 0;">
        <thead>
        <tr>
          <th v-for="(heading, index) in headings" v-bind:key="index"
              v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']"
              @click="changeSorting(heading.sortKey)">
            {{heading.name}}
            <span id="sorttable_sortrevind"
                  v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
            <span id="sorttable_sortfwdind"
                  v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" v-bind:key="item.Objektid"
            :class="{'active': selectedObjekter.includes(item.Objektid)}" @click="showObjektItem($event, item)">
          <td>
            <div class="flex-container">
              <div class="input-container checkbox">
                <input type="checkbox" :value="item.Objektid" v-model="selectedObjekter" :disabled="item.Fakturert == 'F'">
                <span class="glyph"><svg viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>

              <span class="thumbnail-container">
                <span class="thumbnail small placeholder animation">
                  <template v-if="objektThumb(item) && objektLarge(item)">
                    <img class="hi-trigger" :src="objektThumb(item)" :data-hi-src-full="objektLarge(item)" data-hi-size="large" />
                  </template>
                  <template v-else-if="objektThumb(item)">
                    <img :src="objektThumb(item)" />
                  </template>
                  <template v-else>
                    <span class="placeholder"></span>
                  </template>
                </span>
                <a href="javascript:;" class="primary-title">{{item.Objektnr}}</a>
              </span>
            </div>
          </td>
          <td class="show-for-medium">
            {{item.title | truncate(40)}}
            <span class="opacity-60" v-if="item.subtitle"><br>{{item.subtitle | truncate(30)}}</span>
          </td>
          <td class="show-for-medium" v-if="item.kategori">
            {{item.kategori.Kategori}}
          </td>
          <td v-else>-</td>

          <td class="show-for-large align-right">
            <span class="opacity-60">{{item.Minstepris | thousands}}</span>
          </td>

          <td class="show-for-large align-right">
              <span class="opacity-60">{{item.Salar | toFixed}}%</span>
          </td>

          <td class="show-for-large align-right">
              <span class="opacity-60">{{item.fotokostnad_calculated | thousands}} kr</span>
          </td>

          <td class="show-for-medium align-right">
              <span class="opacity-60" v-if="item.Vurderingspris1>0 && item.Vurderingspris2>0">
                {{item.Vurderingspris2 | thousands}} - {{item.Vurderingspris1 | thousands}}
              </span>
            <span v-else>
                <span class="opacity-60" v-if="item.Vurderingspris1>0">
                  {{item.Vurderingspris1 | thousands}}
                </span>
                <span class="opacity-60" v-if="item.Vurderingspris2>0">
                  {{item.Vurderingspris2 | thousands}}
                </span>
              </span>
          </td>

          <td class="show-for-medium align-right">
            {{showTilslag(item)}}
          </td>

          <td class="show-for-large align-right">
            {{item.Antall}}
          </td>

          <td class="show-for-large">
            <span v-if="item.Tekst_ok === 'T'" class="statusicon verified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
            <span v-else class="statusicon unverified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
          </td>
          <td class="show-for-large">
            <span v-if="item.Fototatt === 'T'" class="statusicon verified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
            <span v-else class="statusicon unverified"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
          </td>

          <td class="align-right">
            <span class="status" :class="objektStatus(item).cls">{{objektStatus(item).msg}}</span>
            <!-- <span class="status green" v-if="item.Godkjentforinternett === 'T'">Klar for salg</span>
            <span class="status red" v-else>Ikke klar for salg</span> -->
          </td>
        </tr>
        </tbody>
      </table>

      <div class="pagination-container" v-if="pageCount > 1">
        <paginate v-model="currentPage"
                  :page-count="pageCount"
                  :page-range="11"
                  :click-handler="changePage"
                  :container-class="'pagination'"
                  :prev-text="paginationArrow"
                  :next-text="paginationArrow"
                  :prev-class="'prev'"
                  :next-class="'next'"
        >
        </paginate>
      </div>

      <!-- Selected Objekter Bottom Panel -->
      <div class="checkbox-panel-container" :class="{'active': selectedObjekter.length > 0}">
        <div class="checkbox-panel">
          <div class="grid-x">
            <div class="cell auto">
              <div class="input-container checkbox">
                <input type="checkbox" id="checkall-objekter" @click="toggleSelectAll($event)"
                       :checked="selectedObjekter.length === items.length">
                <label for="checkall-objekter">Marker alle</label>
                <span class="glyph"><svg viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
            </div>
            <div class="cell shrink">
              <span class="count"><span class="checked">{{selectedObjekter.length}}</span> / <span class="total">{{items.length}}</span> markert</span>
            </div>
            <!-- <div class="cell shrink">
              <a href="javascript:;" @click="moveToKontrakt()" class="button primary">Flytt til kontrakt</a>
            </div> -->
            <div class="cell shrink">
              <a href="javascript:;" @click="invoiceAr()" class="button secondary">Fakturer AR</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import moment from 'moment'
import accounting from 'accounting-js'
import {mapGetters} from 'vuex'

export default {
  name: 'KundeKontraktObjektList',
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      headings: [
        {name: 'Objekt', sortKey: 'Lopenr', class: ''},
        {name: 'Tittel', sortKey: 'title', class: 'show-for-medium'},
        {name: 'Kategori', sortKey: 'Kategori', class: 'show-for-medium'},
        {name: 'Minstepris', sortKey: 'Minstepris', class: 'show-for-large align-right'},
        {name: 'Salær', sortKey: 'Salar', class: 'show-for-large align-right'},
        {name: 'Auksjonshonorar', sortKey: 'fotokostnad_calculated', class: 'show-for-large align-right'},
        {name: 'Vurdering', sortKey: 'Vurderingspris2', class: 'show-for-medium align-right'},
        {name: 'Tilslag', sortKey: 'Salgspris', class: 'show-for-medium align-right'},
        {name: 'Antall', sortKey: 'Antall', class: 'show-for-large align-right'},
        {name: 'Objekt ', sortKey: 'Tekst_ok', class: 'show-for-large'},
        {name: 'Foto', sortKey: 'Fototatt', class: 'show-for-large'},
        {name: 'Status', sortKey: '', class: 'align-right'}
      ],
      selectedObjekter: [],
      loadedImages: {}
    }
  },
  updated () {
    /** Skip the sticky js part + added sticky-header-table code to table tag. */
    // setTimeout(function () {
    //   if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
    //     if (!window.jQuery('table.fixed').hasClass('sticky')) {
    //       window.jQuery('table.fixed').addClass('sticky')
    //       window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
    //       console.log('HERE 2')
    //       window.jQuery(window).resize(function () {
    //       })
    //     }
    //   }
    // }, 100)
  },
  mounted () {
    // bus.$on('kontrakt-signert-changed', () => this.onKontraktSignertChanged())
    bus.$on('kontrakt-objekter-deleted', () => this.onObjekterDeleted())
    bus.$on('kontrakt-objekter-transferred', (newKontrakt) => this.onObjekterTransferred(newKontrakt))

    /** Skip the sticky js part + added sticky-header-table code to table tag. */
    // setTimeout(function () {
    //   if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
    //     if (!window.jQuery('table.fixed').hasClass('sticky')) {
    //       window.jQuery('table.fixed').addClass('sticky')
    //       window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
    //       console.log('HERE 1')
    //       window.jQuery(window).resize(function () {
    //       })
    //     }
    //   }
    // }, 100)
  },
  created: function () {
    // bus.$off('kontrakt-signert-changed')
    bus.$off('kontrakt-objekter-deleted')
    bus.$off('kontrakt-objekter-transferred')

    this.currentPage = this.queryParams.page || 1
  },
  computed: {
    ...mapGetters('kundekontraktobjekt', [
      'items',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    }
  },
  watch: {
    'kontrakt.Registrertsignert': function (newVal, oldVal) {
      // If signert changes we need to reload the list.
      this.$store.dispatch('kundekontraktobjekt/reload', {
        kontrakt: this.kontrakt,
        queryParams: this.queryParams
      })
    }
  },
  methods: {
    objektStatus: function (item) {
      const dtoday = new Date().getTime()
      const retval = {
        cls: '',
        msg: ''
      }

      if (Number(item.Avdelingsid) === 0) {
        const auctionDateEnd = item.auksjon && item.auksjon.Auksjon_dato ? Date.parse(item.auksjon.Auksjon_dato) : null

        if (item.Salgspris > 0 && item.Tilslagnr && Number(item.Tilslagnr) !== 950) {
          retval.cls = 'green'
          retval.msg = 'Solgt'
        } else if (item.auksjon && item.auksjon.Auksjontype === 'R') {
          retval.cls = 'green'
          retval.msg = 'Avtalt retur'
        } else if (item.Tekst_ok === 'F' || item.Fototatt === 'F' || (item.kontrakt ? item.kontrakt.Registrertsignert : null) === null) {
          retval.cls = 'red'
          retval.msg = 'Ikke klar for salg'
        } else if (auctionDateEnd && auctionDateEnd < dtoday) {
          retval.cls = 'red'
          retval.msg = 'Usolgt'
        } else {
          retval.cls = 'green'
          retval.msg = 'Klar for salg'
        }
      } else {
        const auctionDateEnd = item.na_max_slutt ? Date.parse(item.na_max_slutt) : null
        const auctionDateStart = item.na_max_start ? Date.parse(item.na_max_start) : null
        const isUnsold = ((item.Tilslagnr && ['', 950].includes(Number(item.Tilslagnr))) || !item.Tilslagnr)

        if ([951, 952].includes(Number(item.Tilslagnr))) {
          retval.cls = 'green'
          retval.msg = 'Solgt'
        } else if (item.auksjon && item.auksjon.Auksjontype === 'R') {
          retval.cls = 'green'
          retval.msg = 'Avtalt retur'
        } else if (isUnsold && auctionDateEnd && auctionDateEnd < dtoday) {
          retval.cls = 'red'
          retval.msg = 'Usolgt'
        } else if (item.Tekst_ok === 'F' || item.Fototatt === 'F' || (item.kontrakt ? item.kontrakt.Registrertsignert : null) === null) {
          retval.cls = 'red'
          retval.msg = 'Ikke klar for salg'
        } else if (auctionDateEnd > dtoday && auctionDateStart > dtoday) {
          retval.cls = 'green'
          retval.msg = 'I kommande auksjon'
        } else if (auctionDateEnd >= dtoday && auctionDateStart <= dtoday) {
          retval.cls = 'green'
          retval.msg = 'I pågående auksjon'
        } else {
          retval.cls = 'green'
          retval.msg = 'Klar for salg'
        }
      }

      return retval
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektLarge: function (item) {
      if (item.photos && item.photos.large && item.photos.large.length > 0) {
        return item.photos.large[0]
      }

      return null
    },
    showTilslag: function (item) {
      if (this._.startsWith(item.Auksjon, 'AR')) {
        return 'Usolgt'
      }

      return item.Salgspris ? accounting.formatNumber(item.Salgspris, {precision: 0, thousand: ' '}) : 0
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = page
        copiedParams.page = vm.currentPage

        vm.$store.dispatch('kundekontraktobjekt/reload', {
          kontrakt: vm.kontrakt,
          queryParams: copiedParams
        })
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundekontraktobjekt/reload', {
        kontrakt: this.kontrakt,
        queryParams: copiedParams
      })
    },
    openCreateObjektModal: function () {
      this.openModal(
        'kunde-kontrakt-objekt-create-modal',
        {
          kunde: this.kunde,
          kontrakt: this.kontrakt
        },
        null,
        'new-object-delete'
      )
    },
    showObjektItem: function (event, item) {
      let isCheckboxClick = event.target.nodeName === 'INPUT'

      window.jQuery('#hi-container').removeClass('active')
      window.jQuery(document).unbind('mousemove')

      if (!isCheckboxClick) {
        this.loadObjektModal(item.Objektid)
        // bus.$emit('show-kunde-kontrakt-objekt', this.kontrakt, item)
      }
    },
    inAuction: function (objekt) {
      if (objekt.auksjonsdato) {
        const today = moment().format('YYYY-MM-DD')
        const adato = moment(moment(objekt.auksjonsdato).format('YYYY-MM-DD'))
        const diff = adato.diff(today)

        if (diff >= 0) {
          return true
        }
      }

      return false
    },
    invoiceAr: function () {
      var vm = this
      let success = []
      let failure = []
      let confirmText = []

      // No selected objects
      if (!this.selectedObjekter) {
        this.$helpers.showErrorAlert('Feil', 'Vennligst velg ett eller flere objekter.')
        return
      }

      // Find out which ones are valid and invalid
      this.selectedObjekter.forEach(id => {
        const found = this.items.find(i => i.Objektid === id)

        if (found !== undefined) {
          // Cannot have salgspris, oppgjorbilagsnr, be in an auction, be invoiced or have a sales number.
          // if (!found.Salgspris && !found.Oppgjorbilagsnr && !this.inAuction(found) && found.Fakturert !== 'F' && found.Salgbilagsnr === null) {
          if (!found.Oppgjorbilagsnr && found.Fakturert !== 'F' && found.Salgbilagsnr === null) {
            success.push(found.Objektnr)
          } else {
            failure.push(found.Objektnr)
          }
        }
      })

      // We found NO valid objects.
      if (success.length === 0) {
        // No successful items
        this.$helpers.showErrorAlert('Feil', 'Ingen av de markerte objektene kan faktureres i retur')
        return
      }

      // We found SOME invalid objects -> so we add some information to the confirm.
      if (failure.length > 0) {
        confirmText = []
        confirmText.push('Følgende objekter er IKKE gyldige for fakturering:')
        confirmText.push('<br>')
        confirmText.push('<em>' + failure.join(', ') + '</em>')
        confirmText.push('<br><br>')
      }

      // We found successful objects
      confirmText.push('Følgende objekter er gyldige for fakturering:')
      confirmText.push('<br>')
      confirmText.push('<em>' + success.join(', ') + '</em>')

      this.openConfirm(
        'Fakturer AR',
        confirmText.join(''),
        'Ja',
        'Nei',
        function () {
          console.log('Ja, fortsett å fakturer AR')
          vm.closeModal()
          bus.$emit('show-kontrakt-invoice-ar', success)
        },
        function () {
          console.log('Nei, skip')
          vm.closeModal()
        }
      )
    },
    moveToKontrakt: function () {
      if (!this.selectedObjekter) {
        this.$helpers.showErrorAlert('Feil', 'Vennligst velg ett eller flere objekter.')
      } else {
        this.openModal('kunde-kontrakt-transfer-modal', {
          kunde: this.kunde,
          kontrakt: this.kontrakt,
          objektlist: this.selectedObjekter
        })
      }
    },
    onObjekterDeleted: function () {
      // Reset selected objekter
      this.selectedObjekter = []

      // Reload list of objekter
      this.$store.dispatch('kundekontraktobjekt/reload', {
        kontrakt: this.kontrakt
      })
    },
    onObjekterTransferred: function (newKontrakt) {
      // Reset selected objekter
      this.selectedObjekter = []

      // Reload list of objekter
      this.$store.dispatch('kundekontraktobjekt/reload', {
        kontrakt: this.kontrakt
      })

      // Show alert with link to newly created kontrakt
      this.$helpers.showSuccessAlert(
        'Et eller flere objekter har blitt flyttet til Kontakt#' + newKontrakt.Kontraktnr,
        '<a href="' + '/kunde/' + this.kunde.Kundenr + '?kontrakt=' + newKontrakt.Kontraktnr + '">Gå til Kontrakt</a>',
        true,
        10000
      )
    },
    toggleSelectAll: function (event) {
      if (event.target.checked) {
        // Checked: true -> add all objektids to the selected-array
        this.selectedObjekter = []
        this.items.forEach(i => {
          this.selectedObjekter.push(i.Objektid)
        })
      } else {
        // Just empty selected-array
        this.selectedObjekter = []
      }
    }
  }
}
</script>
<style scoped>
  input[disabled], input[disabled] + .glyph{
    opacity: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektList.vue